import { connect } from 'react-redux';
import { isFeatureEnabled } from '../../stores/features';

function EnabledFeature({ isEnabled, children, fallbackElement = null }) {
  if (isEnabled) {
    return children;
  }

  if (fallbackElement) {
    return fallbackElement;
  }

  return null;
}

export default connect((store, { name }) => ({
  isEnabled: isFeatureEnabled(store.features, name)
}))(EnabledFeature);
